module.exports = __webpack_public_path__ + "ed336d88f317d2a44646208a5a1e5af8.svg";